import React, { forwardRef } from 'react';
import { SnackbarContent } from 'notistack';

const STYLES = {
  success: {
    background: '#e8f7ef',
    color: '#0d5c3f',
    border: '2px solid #2ecc71',
    boxShadow: '0 8px 24px rgba(46, 204, 113, 0.22)',
  },
  error: {
    background: '#fdecec',
    color: '#8b1a1a',
    border: '2px solid #e74c3c',
    boxShadow: '0 8px 24px rgba(231, 76, 60, 0.22)',
  },
  warning: {
    background: '#fff8e6',
    color: '#7a5a00',
    border: '2px solid #f1c40f',
    boxShadow: '0 8px 24px rgba(241, 196, 15, 0.22)',
  },
  info: {
    background: '#eaf4fc',
    color: '#1a4a7a',
    border: '2px solid #3498db',
    boxShadow: '0 8px 24px rgba(52, 152, 219, 0.22)',
  },
};

const ICONS = {
  success: 'ti-circle-check',
  error: 'ti-alert-circle',
  warning: 'ti-alert-triangle',
  info: 'ti-info-circle',
};

const StyledSnackbar = forwardRef((props, ref) => {
  const { message, variant = 'info' } = props;
  const style = STYLES[variant] || STYLES.info;
  const icon = ICONS[variant] || ICONS.info;

  return (
    <SnackbarContent ref={ref} role="alert">
      <div className="shm-snackbar" style={style} data-variant={variant}>
        <i className={`ti ${icon} shm-snackbar-icon`} aria-hidden />
        <span className="shm-snackbar-message">{message}</span>
      </div>
    </SnackbarContent>
  );
});

StyledSnackbar.displayName = 'StyledSnackbar';

export default StyledSnackbar;
